import { Flex } from 'foundations-components/components/Flex';
import { Small } from 'foundations-components/transitional/components/Small';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import FileContainer from './FileContainer';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FileItemLayout = ({
  icon,
  labelContent,
  actions,
  variant = 'default',
  'data-test-id': dataTestId
}) => {
  return /*#__PURE__*/_jsxs(FileContainer, {
    variant: variant,
    "data-test-id": dataTestId,
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      children: [icon, /*#__PURE__*/_jsx(TruncateString, {
        marginInlineStart: "200",
        children: /*#__PURE__*/_jsx(Small, {
          weight: "demi",
          children: labelContent
        })
      })]
    }), /*#__PURE__*/_jsx(View, {
      marginInlineStart: "100",
      children: actions
    })]
  });
};
export default FileItemLayout;